module.exports = __webpack_public_path__ + "img/2_210.5b784da0.png";